import { configureStore } from "@reduxjs/toolkit";
import leadReducer from "./slices/leadsSlice";
import financialReducer from "./slices/financialSlice";
import sourceSlice from "./slices/sourceSlice";
import statusReducer from "./slices/statusSlice";
import serviceTypesReducer from "./slices/serviceTypesSlice";
import leadTypeReducer from "./slices/leadTypeSlice";
import departmentsReducer from "./slices/departmentsSlice";
import sessionReducer from "./slices/sessionSlice";
import groupReducer from "./slices/groupSlice";
import fileReducer from "./slices/fileSlice";
import dataL3Reducer from "./slices/dataSliceL3";
import filterReducer from "./slices/filterSlice";
import hardwareStoreReducer from "./slices/hardwareStoreSlice";
import labourCostReducer from "./slices/labourCostSlice";
import clientRatingReducer from "./slices/clientRatingDashboardSliceL3";
import ratingsReducer from "./slices/ratingWeightageSlice";
import authReducer from "./slices/credentialsSlice";
import leadReportsReducer from "./slices/globalFilterSlice";
import ratingReducer from "./slices/ratingSlice";
import taxesReducer from "./slices/taxSlice"; // adjust the path
import editableFinanceReducer from "./slices/editFinanceSlice"; // adjust the path
import roleReducer from "./slices/roleSlice";
import projectJournalReducer from "./slices/projectJournal";
import projectRequestedTaskReducer from "./slices/projectRequestedSlice";
import projectApprovedTaskReducer from "./slices/projectApprovedTaskSlice";
import managerProjectRequestedReducer from "./slices/managerProjectRequestedSlice";
import assignedTaskReducer from "./slices/ProjectAssignedTaskSlice";
import projectOngoingTaskReducer from "./slices/ProjectOngoingTask"; // adjust path as needed
import completedTasksReducer from "./slices/ProjectCompletedTask";
import projectsReducer from "./slices/projectsSlice";
import filteredDataReducer from "./slices/filteredDataSlice";
import leadreportfilteredReducer from "./slices/LeadreportfilteredSlice";
import employeeReducer from "./slices/employeeSlice";
import chatReducer from "./slices/chatSlice";
import ClientDetailsReducer from "./slices/clientDetailsSlice";
import pageReducer from "./slices/pageSlice";
import scrollReducer from "./slices/scrollSlice";
import salesTaxesReducer from "./slices/salesTaxesSlice";
import hourlyRateQuotationReducer from "./slices/hourlyRates";
import otherExpensesReducer from "./slices/otherexpenses";
import employeeGroupReducer from "./slices/employeeGroup";
import descriptionTaskReducer from "./slices/DescriptionTask";
import salesFinanceReducer from "./slices/salesFinanceSlice";
import hardwareReducer from "./slices/hardwareSlice";
import companyProfileReducer from "./slices/companyProfileSlice";
import quotationTemplateReducer from "./slices/QuotationTemplateSlice";
import generateQuotationReducer from "./slices/generateQuotationSlice";
import workentriesReducer from "./slices/workentriesSlice";
import hardwareDescriptionReducer from "./slices/hardwareDescriptionSlice";
import autoSaveReducer from "./slices/autosaveSlice";
import submitWorkentriesReducer from "./slices/submitTaskSlice";
import descriptionTaskReducers from "./slices/descriptionTaskSlice";
import reassignSalesTomanagerReducer from "./slices/reassignSalesTomanager";
import managerEditTrackingEntriesReducer from "./slices/managerEditTrackingEntries";
import isTrackingActionReducer from "./slices/isTrackingActionSlice";
import fileDataReducer from "./slices/FileDataSlice";
import opProjectAssignActionReducer from './slices/OpProjectAssignSlices/OpProjectAssignAction'
import managerProjectAssignCompleteReducer from './slices/OpProjectAssignSlices/managerProjectAssignCompleteSlice'
import managerActionReducer from './slices/managerCompleteSlice'
import projectOngoingReducer from './slices/ProjectOngoing/projectOngoingSlice'
import operationStateReducer from "./slices/OperationSlices/operationStateSlice"
import entriesDescriptionReducer from "./slices/Entries&DescriptionSubmitByOm"
import ProjectOngoingUpdateReducer from "./slices/ProjectOngoing/ProjectOngoingUpdateSlice"
import removePrimaryResourcesReducer from "./slices/removePrimaryResourcesSlice";
import remindManagerReducer from "./slices/remindManagerSlice"
import myTrainingsReducer from "./slices/MyTraining/myTrainings"
import myTrainingCreateSliceReducer from "./slices/MyTraining/myTrainingSlice"
import myTrainingFileUploadReducer from "./slices/MyTraining/myTrainingFileUploadSlice"
import groupOneReducer from "./slices/groupOneSlice"
import updateSalesMarginReducer from "./slices/updateSalesMarginSlice";
import notificationReducer from "./slices/NotificationSlices";
import wizardReducer from "./slices/WizardSlice/WizardSlice";
import readReducer from "./slices/readSlice";
import getLeadByQuotationNumberReducer from "./slices/fetchLeadByQuotationNumberSlice"
import taskScrollReducer from "./slices/ProjectOngoing/taskScrollSlice"
import wizardStepReducer from "./slices/WizardSlice/wizardStepSlice"
import inventoryReducer from "./slices/InventorySlice";
import assemblyInventoryReducer from "./slices/assemblyInventorySlice";
import partsInventoryReducer from "./slices/partsInventorySlice";
import importAssemblyInventoryReducer from "./slices/importAssemblyInventorySlice"
import sidebarStateReducer from "./slices/Sidebar/SidebarStateSlice"
import processGuideReducer from "./slices/Sidebar/ProcessGuideSlice"
import leadIdGenerationReducer from "./slices/lead/leadIdGenerationSlice"
import salesHourlyRateReducer from "./slices/salesHourlyRateSlice"
import clientMasterReducer from "./slices/ClientMaster/clientMasterSlice";
import assignSliceReducer from "./slices/ProjectAssign/projectAssignStateSlice";
import operationFeatureReducer from "./slices/ProjectOngoing/operationFeatureSlice";
import updateHardwareReducer from "./slices/HardwareSlice/updateHardwareDataSlice";
import projectAssignCancelStateReducer from "./slices/ProjectAssign/projectAssignCancelStateSlice";

const store = configureStore({
  reducer: {
    session: sessionReducer,
    auth: authReducer,
    employees: employeeReducer,
    leads: leadReducer,
    financial: financialReducer,
    EditableFinance: editableFinanceReducer,
    group: groupReducer,
    source: sourceSlice,
    status: statusReducer,
    serviceTypesRedux: serviceTypesReducer,
    leadTypesRedux: leadTypeReducer,
    departments: departmentsReducer,
    files: fileReducer,
    data: dataL3Reducer,
    filters: filterReducer,
    hardwareStore: hardwareStoreReducer,
    labourCost: labourCostReducer,
    clientRating: clientRatingReducer,
    ratings: ratingsReducer,
    leadReports: leadReportsReducer, // Make sure this matches the slice name
    ratingsfilter: ratingReducer,
    taxes: taxesReducer,
    roles: roleReducer,
    projectJournal: projectJournalReducer,
    projectRequestedTask: projectRequestedTaskReducer,
    projectApprovedTask: projectApprovedTaskReducer,
    managerProjectRequested: managerProjectRequestedReducer,
    assignedTasks: assignedTaskReducer,
    projectOngoingTasks: projectOngoingTaskReducer,
    completedTasks: completedTasksReducer,
    projects: projectsReducer,
    filteredData: filteredDataReducer,
    leadreportfiltered: leadreportfilteredReducer,
    chat: chatReducer,
    client: ClientDetailsReducer,
    page: pageReducer,
    employeeGroup: employeeGroupReducer,
    scroll: scrollReducer,
    salesTaxes: salesTaxesReducer,
    hourlyRateQuotation: hourlyRateQuotationReducer,
    otherExpenses: otherExpensesReducer,
    descriptionTasks: descriptionTaskReducer,
    salesFinance: salesFinanceReducer,
    hardware: hardwareReducer,
    companyProfile: companyProfileReducer,
    quotationTemplates: quotationTemplateReducer,
    generateQuotation: generateQuotationReducer,
    workentries: workentriesReducer,
    hardwareDescription: hardwareDescriptionReducer,
    autosave: autoSaveReducer,
    submitWorkEntries: submitWorkentriesReducer,
    descriptionTask: descriptionTaskReducers,
    reassignSalesTomanager: reassignSalesTomanagerReducer,
    fileData: fileDataReducer,
    managerEditTrackingEntries: managerEditTrackingEntriesReducer,
    trackingAction: isTrackingActionReducer,
    opProjectAssignAction: opProjectAssignActionReducer,
    managerProjectAssignComplete: managerProjectAssignCompleteReducer,
    projectOngoing: projectOngoingReducer,
    managerAction: managerActionReducer,
    operationState: operationStateReducer,
    entriesDescription: entriesDescriptionReducer,
    projectOngoingUpdate: ProjectOngoingUpdateReducer, // register it here
    removePrimaryResources: removePrimaryResourcesReducer,
    remindManager: remindManagerReducer,
    myTrainings: myTrainingsReducer, // ✅ Add here
    myTrainingFileUpload: myTrainingFileUploadReducer,
    groupOne: groupOneReducer,
    updateSalesMargin: updateSalesMarginReducer,
    myTrainingsCreate: myTrainingCreateSliceReducer, // name must match your slice
    notifications: notificationReducer,
    wizard: wizardReducer,
    read: readReducer,
    getLeadByQuotation: getLeadByQuotationNumberReducer,
    taskScroll: taskScrollReducer,
    wizardstep: wizardStepReducer,
    inventory: inventoryReducer,
    assemblyInventory: assemblyInventoryReducer,
    partsInventory: partsInventoryReducer,
    importAssemblyInventory: importAssemblyInventoryReducer,
    sidebar: sidebarStateReducer,
    leadIdGeneration: leadIdGenerationReducer,
    salesHourlyRate: salesHourlyRateReducer,
    clientMaster: clientMasterReducer,
    assignSlice: assignSliceReducer,
    operationFeature: operationFeatureReducer,
    updateHardware: updateHardwareReducer,
    projectAssignCancelState: projectAssignCancelStateReducer,
    processGuide: processGuideReducer,
  },
});

export default store;
